import { UrlConstants } from "../url.constants";
export class ApiSurvey123Constants {
    static URL = UrlConstants.API_V2 + "Survey123";
    static FUNCTION_REQUEST_SURVEY = "RequestSurvey";
    static FUNCTION_GET_SURVEY_DATA = "GetSurveyData";
    static FUNCTION_GET_ALL_SURVEY_DATA = "GetAllSurveyData";
    static FUNCTION_GET_ALL_SURVEYS = "GetAllSurveys";
    static FUNCTION_ADD_SURVEY_NOTIFICATION = "AddSurveyNotification";
    static FUNCTION_ADD_PERSON_NOTIFICATION = "AddPersonNotification";
}
